import axios from '../utils/axios';

export default function getDomainList(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/domain-info', { params })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            })
    )
}